import React from 'react';
import womanHeartSticker from '../../assets/woman-heart.png';

// Logo from public folder - accessed via absolute path
const dubaiPoliceLogo = '/transparent-logo-vertical.png';

const WelcomeScreen = ({ onStartClick }) => {
  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-white via-[#F6FBF9] to-[#E4EFEA]">
      {/* Vertical spine - left authority bar */}
      <div className="forensic-spine" />
      <div className="forensic-spine-text">
        WOMEN PROTECTION PLATFORM — DUBAI POLICE — 2025
      </div>

      {/* Background layers */}
      <div className="forensic-grid-overlay" />
      <div className="forensic-map-overlay" />
      <div className="forensic-digital-noise" />
      <div className="forensic-fingerprint-texture" />
      <div className="forensic-circuit-lines" />

      {/* Geometric green blocks */}
      <div className="forensic-block forensic-block-1" />
      <div className="forensic-block forensic-block-2" />
      <div className="forensic-block forensic-block-3" />
      <div className="forensic-corner-tl" />
      <div className="forensic-corner-br" />

      {/* Decorative sticker - bottom left corner */}
      <img
        src={womanHeartSticker}
        alt=""
        className="absolute bottom-8 left-8 w-48 h-auto opacity-15 pointer-events-none select-none"
      />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col">
        {/* Header with centered logo */}
        <header className="flex justify-center items-center px-8 pt-6 pb-4">
          <img
            src={dubaiPoliceLogo}
            alt="Dubai Police"
            className="h-24 w-auto"
          />
        </header>

        {/* Header line */}
        <div className="h-[2px] mx-8 bg-gradient-to-r from-[#0e734b] via-[#0e734b] to-transparent" style={{ backgroundSize: '60% 100%', backgroundRepeat: 'no-repeat' }} />

        {/* Main content area */}
        <main className="flex-1 flex flex-col items-center justify-center px-8 text-center">
          {/* Event Title - Bilingual */}
          <div className="space-y-2 mb-6">
            <h1 className="text-[3.5rem] font-black text-[#0e734b] leading-tight font-arabic" dir="rtl">
              منصة حماية المرأة
            </h1>
            <h2 className="text-[2.5rem] font-title uppercase text-[#1A1A1A] leading-tight">
              WOMEN PROTECTION PLATFORM
            </h2>
          </div>

          {/* Arabic tagline */}
          <p className="text-xl font-bold mb-2 font-arabic" dir="rtl">
            <span className="text-[#4A5550]">ندعم.</span>
            {' '}
            <span className="text-[#0e734b]">نُمكّن.</span>
            {' '}
            <span className="text-[#4A5550]">نحمي.</span>
          </p>

          {/* English tagline */}
          <p className="text-2xl font-tagline uppercase mb-4">
            <span className="text-[#1A1A1A]">SUPPORT.</span>
            {' '}
            <span className="text-[#0e734b]">EMPOWER.</span>
            {' '}
            <span className="text-[#1A1A1A]">PROTECT.</span>
          </p>

          {/* Subtitle */}
          <div className="space-y-1 mb-10">
            <p className="text-sm text-[#4A5550] font-arabic font-medium" dir="rtl">
              أنتِ <span className="text-[#E8733A] font-bold">بطلة</span> حياتك. تستحقين الدعم.
            </p>
            <p className="text-sm text-[#6B7770] font-title-light">
              You are the <span className="text-[#E8733A] font-bold">HERO</span> of your life. You deserve support.
            </p>
          </div>

          {/* CTA Button - Bilingual */}
          <button
            onClick={onStartClick}
            className="forensic-btn-primary text-xl px-16 py-5 mb-8 flex items-center gap-3"
          >
            <span className="font-title uppercase">Begin</span>
            <span className="text-white/60">|</span>
            <span className="font-arabic font-bold">ابدأ</span>
          </button>

        </main>

        {/* Footer */}
        <footer className="flex-shrink-0 pb-6 text-center">
          <p className="text-sm font-bold tracking-[0.3em] uppercase text-[#0e734b]">
            DUBAI POLICE
          </p>
        </footer>
      </div>
    </div>
  );
};

export default WelcomeScreen;
